import { defineComponent as _defineComponent } from 'vue'
import BCXButton from '@/components/molecules/BCXButton.vue';
import MyProjectsButtonArea from '@/views/my-projects/components/MyProjectsButtonArea.vue';
import { computed, toRef, ref } from 'vue';
import useUser from '@/mixins/useUser';
import useContract from '../../composables/useContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectContractButtonArea',
  props: {
  isCreatingDocument: {
    type: Boolean,
    default: false,
  },
  isDeletingDocument: {
    type: Boolean,
    default: false,
  },
},
  emits: ['new-document', 'open-chat', 'delete-document'],
  setup(__props, { emit }) {

const props = __props;

const {
  openContractDocumentId, contractDetail, isContractStatusOpen
} = useContract();
const { userId } = useUser('self');





const isCreatingDocument = toRef(props, 'isCreatingDocument');

const canDeleteContractDocument = computed(() => {
  if (!openContractDocumentId.value) {
    return false;
  }
  const contractDocument = contractDetail.value?.documents.find((document) => document.id === openContractDocumentId.value);
  const isUserCreatorOfDocument = contractDocument?.creator?.userId === userId.value;

  // The button may only be displayed if an existing document is open and the user is the creator
  return (contractDocument?.files?.length ?? 0) === 0 && isUserCreatorOfDocument;
});

const hasRecentlyCreatedDocument = ref(false);
const recentlyCreatedDebouncePeriod = 1000;

const createDocument = () => {
  if (hasRecentlyCreatedDocument.value) {
    return;
  }

  hasRecentlyCreatedDocument.value = true;
  setTimeout(() => {
    hasRecentlyCreatedDocument.value = false;
  }, recentlyCreatedDebouncePeriod);

  emit('new-document');
};

return { __sfc: true,openContractDocumentId, contractDetail, isContractStatusOpen, userId, props, emit, isCreatingDocument, canDeleteContractDocument, hasRecentlyCreatedDocument, recentlyCreatedDebouncePeriod, createDocument, BCXButton, MyProjectsButtonArea }
}

})